<template>
  <div class="ac-content-wrapper">
    <div class="header" style="font-weight: 500;">
      Select primary brand color
    </div>
    <div class="sub-header">
      This setting will control the cobranded color shown in the Member app
    </div>
    <div class="ac-input-container">
      <SACColorPicker
        :color="primaryColor"
        :change="(v) => onChange('primaryColor', v)"
        :disable="adminRole !== 'admin'"
      />
    </div>
  </div>
</template>

<script>
import SACColorPicker from '@shared/components/sac/SACColorPicker.vue';

export default {
  name: 'PrimaryColor',
  components: {
    SACColorPicker,
  },
  props: {
    adminRole: String,
    primaryColor: String,
    onChange: Function,
  },
};
</script>
